export enum Colors {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Primary = 'primary',
  TextPrimary = 'text-primary',
  Inherit = 'inherit',
}
